import { render, staticRenderFns } from "./successCover.vue?vue&type=template&id=16163b1d&scoped=true&"
import script from "./successCover.vue?vue&type=script&lang=js&"
export * from "./successCover.vue?vue&type=script&lang=js&"
import style0 from "./successCover.vue?vue&type=style&index=0&id=16163b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16163b1d",
  null
  
)

export default component.exports